import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/ui/Button/Button";
import { Link } from "../../components/ui/Link/Link";
import { NotFoundContainer, ErrorCode, Title, Description } from "./NotFound.styles";

export const NotFound: React.FC = () => {
  const { t } = useTranslation("common");

  return (
    <NotFoundContainer>
      <ErrorCode>404</ErrorCode>
      <Title>{t("page_not_found", "Page not found")}</Title>
      <Description>
        {t("page_not_found_desc", "The page you are looking for doesn't exist or has been moved.")}
      </Description>
      <Link to="/dashboard">
        <Button variant="primary">
          {t("back_to_dashboard", "Back to dashboard")}
        </Button>
      </Link>
    </NotFoundContainer>
  );
};
